import {
    BannerType,
    BannerViewModel,
    EsportsBannerViewModel,
    SportsGamesBannerViewModel,
    SportsJackpotBannerViewModel,
    SportsLinkBannerViewModel,
    VirtualSportsBannerViewModel,
} from '@frontend/sports/types/components/banners/models';
import { VymlGame } from '@frontend/sports/types/components/banners/vyml';

import { CrossSaleTracking } from './cross-sale-tracking.model';

export enum ChannelIds {
    Android = 'AW',

    IOS = 'IW',

    WC = 'WC',
}

export interface TickModel {
    isDigit?: boolean;
    isCurrency?: boolean;
    isSeparator?: boolean;
    currency?: string;
    digit?: number;
    separator?: string;
}

export interface JackpotValues {
    [jackpotGroup: string]: number;
}

export abstract class JackpotEvent {}

export class JackpotIncrementEvent extends JackpotEvent {
    constructor(public incrementBy: number) {
        super();
    }
}

export interface VymlGamesModel extends VymlGame {
    tilePosition: number;
}

export class JackpotRefreshEvent extends JackpotEvent {
    constructor(public newValues: JackpotValues) {
        super();
    }
}

export interface BannerTrackingModel {
    crossSellProduct: string;
    lobbyPosition: string;
    crossSellName: string;
    gameName: string;
    url: string;
    crossSellActionEvent: string;
    index?: number;
}

export interface GameTrackingModel {
    name: string;
    index: number;
    displayName: string;
    lobbyPosition: string;
    pageName: string;
    url: string;
}

export interface VymlTrackingModel extends GameTrackingModel {
    section: CrossSaleTracking;
}

export interface GymlTrackingModel extends GameTrackingModel {
    provider: string;
}

export enum KycStatus {
    Default = 0,
    Verified = 1,
    NonVerified = 2,
}

export function ofType(model: BannerViewModel, type: 'CasinoLink' | 'SportLink'): model is SportsLinkBannerViewModel;
export function ofType(model: BannerViewModel, type: 'Esport'): model is EsportsBannerViewModel;
export function ofType(model: BannerViewModel, type: 'Games'): model is SportsGamesBannerViewModel;
export function ofType(model: BannerViewModel, type: 'Jackpot'): model is SportsJackpotBannerViewModel;
export function ofType(model: BannerViewModel, type: 'Vyml'): model is VirtualSportsBannerViewModel;
export function ofType(model: BannerViewModel, type: `${BannerType}`) {
    return model.type === type;
}
